/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Box, Flex } from '@radix-ui/themes';

import { css, styled } from 'fierry/react';

import SchemeSwitcher from 'solis/claude/layout/scheme.switcher';
import UserSwitcher from 'solis/claude/layout/user.switcher';

import Empty from 'solis/react/layout/empty';


const Root = styled(Flex)`

  flex-direction: column;
  flex-grow: 1;

  position: relative;
  overflow: hidden;
`;


const ToolbarContainer = styled(Flex)`

  height: 64px;
  flex-shrink: 0;

  align-items: center;
  gap: var(--space-3);

  padding-left: var(--space-4);
  padding-right: var(--space-4);

  ${props => props.$overlay && css`

    position: absolute;

    top: 0;
    left: 0;
    right: 0;

    z-index: 1;
    pointer-events: none;

    > *
    {
      pointer-events: auto;
    }
  `}
`;


const Spacer = styled(Box)`

  flex-grow: 1;
  pointer-events: none;
`;


const BodyContainer = styled(Box)`

  flex-grow: 1;
  overflow: auto;
`;


export default ({ toolbar: Toolbar = Empty, body: Body = Empty, overlay }) =>
(
  <Root>

    <ToolbarContainer $overlay = {overlay}>

      <Toolbar />
      <Spacer />
      <UserSwitcher />
      <SchemeSwitcher />

    </ToolbarContainer>

    <BodyContainer asChild>

      <main>
        <Body />
      </main>

    </BodyContainer>

  </Root>
);
